import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Single source of truth for the app's look — every antd component (buttons,
// tables, menus, pagination, pickers…) inherits these tokens, instead of each
// screen hand-patching its own one-off styles.
const theme = {
  token: {
    colorPrimary: '#2f6fed',
    colorSuccess: '#22a94c',
    colorWarning: '#e8a33d',
    colorError: '#e5383b',
    colorInfo: '#2f6fed',
    borderRadius: 8,
    fontFamily: "'IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    colorBgLayout: '#f8f9fb',
    colorTextBase: '#16181d',
    colorBorder: '#e5e7eb',
  },
  components: {
    Menu: {
      darkItemBg: '#17191f',
      darkItemSelectedBg: '#2f6fed',
      darkSubMenuItemBg: '#17191f',
    },
    Layout: {
      siderBg: '#17191f',
      headerBg: '#fff',
    },
    Card: {
      borderRadiusLG: 12,
    },
    Table: {
      borderRadius: 8,
      headerBg: '#f8f9fb',
    },
    Statistic: {
      contentFontSize: 24,
    },
  },
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ConfigProvider theme={theme}>
      <App />
    </ConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
